interface TruckLike {
	payload?: number;
	priceForTransporter?: number;
	priceForTransporterWithVat?: number;
}

interface OrderLike {
	quantity?: number;
	trucks?: TruckLike[] | null;
	priceForTransporter?: number;
	priceForTransporterWithVat?: number;
}

const hasTrucks = (order?: OrderLike | null): boolean =>
	!!order?.trucks?.length;

/**
 * Ordered quantity shown in the product column: the trucks' payloads, or the
 * order quantity when the row carries no trucks (an offer whose trucks were
 * all taken comes back without the `trucks` field at all).
 */
export const orderTrucksQuantity = (order?: OrderLike | null): number =>
	hasTrucks(order)
		? order!.trucks!.reduce((sum, truck) => sum + (truck?.payload ?? 0), 0)
		: order?.quantity ?? 0;

/**
 * Carrier price of an offer: the sum over its open trucks, falling back to the
 * order-level carrier price when the trucks are missing.
 */
interface CarrierPrices {
	priceForTransporter: number;
	priceForTransporterWithVat: number;
}

export const carrierOfferPrices = (order?: OrderLike | null): CarrierPrices => {
	if (!hasTrucks(order)) {
		return {
			priceForTransporter: order?.priceForTransporter ?? 0,
			priceForTransporterWithVat: order?.priceForTransporterWithVat ?? 0,
		};
	}
	return order!.trucks!.reduce<CarrierPrices>(
		(acc, truck) => ({
			priceForTransporter:
				acc.priceForTransporter + (truck?.priceForTransporter ?? 0),
			priceForTransporterWithVat:
				acc.priceForTransporterWithVat +
				(truck?.priceForTransporterWithVat ?? 0),
		}),
		{ priceForTransporter: 0, priceForTransporterWithVat: 0 },
	);
};
